import { createDrawingObject, replaceLastPoint } from "../shared";
import { toOverlayPrimitive } from "../overlayPrimitiveAdapter";
import { hitTestOverlayPrimitive, renderOverlayPrimitiveToCanvas } from "@vninvestcharts/engine-core";
function renderGhostFeed(ctx, drawing, scales, options) {
    const primitive = toOverlayPrimitive(drawing, scales, {
        chartWidth: options.chartWidth,
        chartHeight: options.chartHeight,
    });
    if (primitive) {
        renderOverlayPrimitiveToCanvas(ctx, primitive, options);
    }
}
function hitTestGhostFeed(drawing, point, scales, tolerance) {
    const primitive = toOverlayPrimitive(drawing, scales);
    if (!primitive)
        return false;
    return hitTestOverlayPrimitive(primitive, point.pixelX, point.pixelY, { tolerance, chartWidth: 800, chartHeight: 600 });
}
const GhostFeed = {
    name: "ghostFeed",
    createDraft: (startPoint) => createDrawingObject("ghostFeed", [startPoint], {
        style: { stroke: "#AA00FF", strokeWidth: 1, opacity: 0.3 },
    }),
    updateDraft: (draft, nextPoint) => replaceLastPoint(draft, nextPoint),
    render: () => undefined,
    hitTest: hitTestGhostFeed,
};
export default GhostFeed;
